import { useRouter } from "vue-router";
import { createOrderApi } from "@/api/order";
import { useAppStoreActions } from "@/hooks/store/useApp";
import useToast from "@/hooks/useToast";
import { jsonToFormData } from "@/utils/jsonToFormData";
import { removeEmpty } from "@/utils/removeEmptyProperty";

// How every new order is sent — quick order entry's review step and syncing a preview
// both go through here, so the two can never drift apart. Resolves to whether the order
// was created, so a form can stay open with what was typed when it was not.
//
// showLoader: false leaves the app's loader alone. It sits under any open modal, so a
// modal that sends an order shows a loader of its own instead.
export const useSubmitOrder = () => {
  const { setLoading } = useAppStoreActions();
  const router = useRouter();
  const { openToast } = useToast();

  const submitOrder = (orderData, { showLoader = true } = {}) => {
    if (showLoader) setLoading(true, { text: "Creating order. Please wait" });
    const entries = jsonToFormData(orderData);
    removeEmpty(entries);
    return createOrderApi(entries)
      .then((res) => {
        router.push(`/crm/orders/order/${res.data.orderId[0]}`);
        return true;
      })
      .catch((e) => {
        openToast(`Order creation error: ${JSON.stringify(e)}`, "danger");
        return false;
      })
      .finally(() => {
        if (showLoader) setLoading(false);
      });
  };

  return { submitOrder };
};
